import { render } from "./PriceListHistoryLog.vue?vue&type=template&id=3d63a612&scoped=true"
import script from "./PriceListHistoryLog.vue?vue&type=script&lang=js"
export * from "./PriceListHistoryLog.vue?vue&type=script&lang=js"

import "./PriceListHistoryLog.vue?vue&type=style&index=0&id=3d63a612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d63a612"]])

export default __exports__